import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Blank from '../../hoc/Blank/Blank';


class CustomerOrder extends Component {
    state = {
       
    }

    componentDidMount () {        
       
        
    }

    componentDidUpdate(prevProps) {
           
    }

    validatePage ()  {
      
    }


    validateIdentifier (identifier) 
    {
        
    }


       

    render () {
        


        return (
            <Blank>
                OK This will ne where the order data goes
            </Blank>
        );
    }
}


const mapStateToProps = state => {
    return {
     
    };
}

const mapDispatchToProps = dispatch => {
    return {
        
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(CustomerOrder);


// WEBPACK FOOTER //
// ./src/containers/CustomerOrder/CustomerOrder.js